"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("./icon"));

require("../css/footer.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(_ref) {
  var children = _ref.children,
      copyrightText = _ref.copyrightText,
      logo = _ref.logo,
      menuEnabled = _ref.menuEnabled;
  var footerClasses = {
    'vn-footer': true,
    'vn-footer__menu--enabled': menuEnabled
  };
  return _react.default.createElement("footer", {
    className: (0, _classnames.default)(footerClasses)
  }, _react.default.createElement(_icon.default, {
    className: "vn-footer__logo",
    name: logo,
    size: 32
  }), copyrightText, _react.default.createElement("div", {
    className: "vn-footer__children"
  }, children));
};

Footer.propTypes = {
  children: _propTypes.default.node,
  copyrightText: _propTypes.default.string,
  logo: _propTypes.default.string,
  menuEnabled: _propTypes.default.bool
};
Footer.defaultProps = {
  children: null,
  copyrightText: '',
  logo: 'hp',
  menuEnabled: false
};
Footer.displayName = 'Footer';
var _default = Footer;
exports.default = _default;